<template>
  <div class="text-center section-height">
    <div class="row">
      <div class="col-12 offset-md-3 col-md-6">
        <row-section-header>
          <span slot="title">
            Let's Get In Touch
          </span>
        </row-section-header>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 offset-md-4">
        <a href="mailto:stephanie.taniguchi@gmail.com?Subject=Hey,%20Stephanie" target="_top">
          <img class="img icon m-3 pt-3" src="@/../static/ICONEmail.svg" alt="email">
        </a>
        <p>stephanie.taniguchi@gmail.com</p>
      </div>
      <div class="col-12 col-md-4 offset-md-4">
        <img class="img icon m-3 pt-3" src="@/../static/ICONLocation.svg" alt="location">
        <p>Located in Vancouver, BC</p>
      </div>
      <div class="col-12 col-md-4 offset-md-4">
        <a href="https://www.linkedin.com/in/stephanietaniguchi/" target="_blank">
          <img class="img icon m-3 pt-3" src="@/../static/ICONLinkedIN.svg" alt="location">
        </a>
        <a href="http://www.instagram.com/haffajappa" target="_blank">
          <img class="img icon m-3 pt-3" src="@/../static/ICONInstagram.svg" alt="location">
        </a>
        <p>More Ways To Connect</p>
      </div>
    </div>
  </div>
</template>

<script>
import AffixedSectionBase from '@/components/AffixedSectionBase.js'

export default {
  name: 'contact',
  mixins: [AffixedSectionBase],
}
</script>

<style lang="scss" scoped>
img.icon {
  width: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/sections/main/Contact.vue